import { generateHTML, generateJSON } from '@tiptap/react';
import descriptionExtensions from './descriptionExtensions';

// Round-trips through the editor schema so only what the editor can produce is rendered.
const sanitizeDescription = html =>
	html ? generateHTML(generateJSON(html, descriptionExtensions), descriptionExtensions) : '';

export default sanitizeDescription;
